import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allowAnalytics: false,
  initialized: false,
  showBanner: false,
};

const cookieConsentSlice = createSlice({
  name: 'cookieConsent',
  initialState,
  reducers: {
    setAllowAnalytics(state, action) {
      state.allowAnalytics = action.payload;
    },
    setInitialized(state, action) {
      state.initialized = action.payload;
    },
    setShowBanner(state, action) {
      state.showBanner = action.payload;
    },
  },
});

export const { setAllowAnalytics, setInitialized, setShowBanner } = cookieConsentSlice.actions;
export default cookieConsentSlice.reducer;
